// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 4 hooks for backend/lpg.

import { useBackend } from '../useBackend'

/** POST /api/lpg/endLpgConversion */
export function useEndLpgConversion<T = any>() {
  return useBackend<T>('lpg/endLpgConversion')
}

/** POST /api/lpg/getLpgPage */
export function useGetLpgPage<T = any>() {
  return useBackend<T>('lpg/getLpgPage')
}

/** POST /api/lpg/recordLpgConversion */
export function useRecordLpgConversion<T = any>() {
  return useBackend<T>('lpg/recordLpgConversion')
}

/** POST /api/lpg/recordLpgPrice */
export function useRecordLpgPrice<T = any>() {
  return useBackend<T>('lpg/recordLpgPrice')
}
